import Markdown from 'markdown-to-jsx';
import { useState } from 'react';
import CopySVG from '../../assets/images/icons/CopySVG';
import useEmailSubjectApiCall from '../../hooks/useEmailSubjectApiCall';
import copyToClipboard from '../../utils/clipboard-helper';

const EmailSubject: React.FC = () => {
	// form code
	const [businessUnit, setBusinessUnit] = useState('');
	const [tone, setTone] = useState('');
	const [wordLimit, setWordLimit] = useState('');
	const [urlText, setUrlText] = useState('');
	const [copyButtonText, setCopyButtonText] = useState('Copy');

	const { loading, output, handleSubmit } = useEmailSubjectApiCall();

	// copy response on click
	const handleCopyToClipboard = () => {
		copyToClipboard(output, setCopyButtonText);
	};

	return (
		<div>
			<div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
				<h1 className="text-lg font-semibold mb-4 leading-6 text-gray-900">Email - Subject line generation</h1>
				<div>
					<div className="mb-6">
						<div className="mb-4">
							<label htmlFor="urlText" className="block text-sm font-medium leading-6 text-gray-900">
								Enter url
							</label>
							<div className="mt-2">
								<input
									type="text"
									name="urlText"
									id="urlText"
									className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6"
									placeholder=""
									value={urlText}
									onChange={(e) => setUrlText(e.target.value)}
								/>
							</div>
						</div>
						<div className="mb-4">
							<label htmlFor="businessUnit" className="block text-sm font-medium leading-6 text-gray-900">
								Business Unit
							</label>
							<div className="mt-2">
								<select
									value={businessUnit}
									onChange={(e) => setBusinessUnit(e.target.value)}
									className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6"
								>
									<option value="eAndW">E&W</option>
									<option value="massMarkets">Mass Markets</option>
								</select>
							</div>
						</div>
						<div className="mb-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
							<div className="sm:col-span-3">
								<label htmlFor="tone" className="block text-sm font-medium leading-6 text-gray-900">
									Tone
								</label>
								<div className="mt-2">
									<select
										value={tone}
										onChange={(e) => setTone(e.target.value)}
										className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6"
									>
										<option value="casual">Casual</option>
										<option value="Professional">Professional</option>
										<option value="Informational">Informational</option>
										<option value="CallToAction">Call-to-Action (CTA)</option>
										<option value="Enthusiastic">Enthusiastic</option>
										<option value="Selling">Selling</option>
									</select>
								</div>
							</div>
							<div className="sm:col-span-3">
								<label htmlFor="wordLimit" className="block text-sm font-medium leading-6 text-gray-900">
									Word limit
								</label>
								<div className="mt-2">
									<select
										value={wordLimit}
										onChange={(e) => setWordLimit(e.target.value)}
										className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6"
									>
										<option value="5">5</option>
										<option value="10">10</option>
										<option value="15">15</option>
									</select>
								</div>
							</div>
						</div>
						<div className="mb-4">
							<button
								type="button"
								className="rounded-md bg-[#f8c246] px-4 py-2.5 text-sm font-semibold text-black shadow-sm hover:bg-[#f8c246] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
								onClick={() => handleSubmit(urlText, tone, wordLimit)}
							>
								{loading ? 'Loading...' : 'Give me subject lines'}
							</button>
						</div>
					</div>
					{output && (
						<div>
							<div className="flex justify-between mb-4 items-center">
								<h3 className="font-medium">Generated email subject lines</h3>
								<button
									onClick={handleCopyToClipboard}
									type="button"
									className="border px-2 py-1 text-sm font-semibold rounded flex gap-1 items-center"
								>
									<CopySVG />
									{copyButtonText}
								</button>
							</div>
							<div className="responseWrapper p-4 border rounded-md border-gray-300">
								<Markdown>{output}</Markdown>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
export default EmailSubject;
